import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";

import {
  productTypePackage,
  productTypeTire,
} from "../../../constants/productTypes";
import { usePackageEditorSetting } from "../../../hooks/usePackageEditorSetting";
import { useGetVehiclePartTypes } from "../../../queries/useGetVehiclePartTypes";
import { ArrowLeftIcon } from "../../../ui/icons/ArrowLeftIcon";

export const PackageResultsLink: FunctionComponent<{ className?: string }> = ({
  className,
}) => {
  const { t } = useTranslation();
  const isVisible = usePackageEditorSetting();
  const { data: partTypes } = useGetVehiclePartTypes();

  const isTireResults = window.location.href.includes(productTypeTire);

  const hasPackages: boolean =
    partTypes?.some((partType) => partType.value === productTypePackage) ??
    false;

  if (!isTireResults || !isVisible || !hasPackages) {
    return null;
  }

  const packageResultsLink = window.location.href
    .replace(window.location.origin, "")
    .replace(productTypeTire, productTypePackage);

  return (
    <Link
      className={clsx(
        "rounded-tw-full bg-primary text-paper text-sm px-2 h-8 flex items-center gap-1 col-span-2",
        className
      )}
      href={packageResultsLink}
    >
      <ArrowLeftIcon className="w-4 h-4 text-paper rotate-180" />
      {t("searchResults.packageResultsLink")}
    </Link>
  );
};
